import Http from '@/services/http';
import { TimezoneDefinition } from 'sigma-mappings';

const urls = {
  getTimezones: '/timezones',
};

export default {
  getTimezones() {
    const http = new Http();
    return http.get(urls.getTimezones)
      .then(({ data }) => new TimezoneDefinition(data));
  },
};
